import { render, staticRenderFns } from "./AgreementHistory.vue?vue&type=template&id=64d5ae98&scoped=true"
import script from "./AgreementHistory.vue?vue&type=script&lang=ts"
export * from "./AgreementHistory.vue?vue&type=script&lang=ts"
import style0 from "./AgreementHistory.vue?vue&type=style&index=0&id=64d5ae98&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64d5ae98",
  null
  
)

export default component.exports